import { render, staticRenderFns } from "./RamsMultipleSignatureRequest.vue?vue&type=template&id=592568c0&"
import script from "./RamsMultipleSignatureRequest.vue?vue&type=script&lang=js&"
export * from "./RamsMultipleSignatureRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports